export default {
    title_list: 'Units',
    title_page: 'Unit',
    title_create_page: 'Create unit',
    title_edit_page: 'Change unit',

    filter: {
        labels: {
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            type_id: 'Type',
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        type_id: 'Type',
    },
}
